/**
 * Profile & Settings tabs
 */

document.addEventListener('DOMContentLoaded', function() {
  var tabs = document.querySelectorAll('.profile-settings-tab[data-tab]');
  var panels = document.querySelectorAll('.profile-settings-panel[data-panel]');

  if (tabs.length && panels.length) {
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.getAttribute('data-tab');

        tabs.forEach(function(item) {
          item.classList.toggle('is-active', item === tab);
        });

        panels.forEach(function(panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-panel') === target);
        });
      });
    });
  }

  var passwordToggles = document.querySelectorAll('.profile-settings-field--icon .profile-settings-field__icon');

  if (passwordToggles.length) {
    passwordToggles.forEach(function(toggle, index) {
      var field = toggle.closest('.profile-settings-field--icon');
      if (!field) return;
      var input = field.querySelector('input');
      if (!input) return;

      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-controls', input.id || ('profile-password-' + index));
      if (!input.id) input.id = 'profile-password-' + index;
      toggle.setAttribute('aria-label', 'Show password');
      toggle.setAttribute('aria-pressed', 'false');

      function togglePasswordVisibility() {
        var isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        toggle.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
        toggle.setAttribute('aria-pressed', isPassword ? 'true' : 'false');
      }

      toggle.addEventListener('click', function() {
        togglePasswordVisibility();
      });

      toggle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          togglePasswordVisibility();
        }
      });
    });
  }

  var twofaToggle = document.querySelector('[data-twofa-toggle]');
  var twofaModal = document.querySelector('[data-twofa-modal]');
  if (twofaToggle && twofaModal) {
    var closeButtons = twofaModal.querySelectorAll('[data-twofa-close]');
    var copyButton = twofaModal.querySelector('[data-twofa-copy]');
    var codeValue = twofaModal.querySelector('[data-twofa-code]');

    function openTwofaModal() {
      twofaModal.classList.add('is-open');
      twofaModal.setAttribute('aria-hidden', 'false');
    }

    function closeTwofaModal() {
      twofaModal.classList.remove('is-open');
      twofaModal.setAttribute('aria-hidden', 'true');
    }

    twofaToggle.addEventListener('change', function() {
      if (twofaToggle.checked) {
        openTwofaModal();
      }
    });

    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        closeTwofaModal();
      });
    });

    twofaModal.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeTwofaModal();
      }
    });

    if (copyButton && codeValue && navigator.clipboard) {
      copyButton.addEventListener('click', function() {
        navigator.clipboard.writeText(codeValue.textContent || '');
      });
    }
  }
});
